import { createStyledBreakpointsTheme } from 'styled-breakpoints'

const getPrimaryTheme = (colorMode: 'light' | 'dark', tenant: Tenant) =>
  ({
    colorMode: colorMode,
    backgroundColor: colorMode === 'light' ? '#ffffff' : '#121212',
    backgroundColorRGB: colorMode === 'light' ? '255,255,255' : '18,18,18',
    backgroundColorInverted: colorMode === 'dark' ? '#ffffff' : '#222426',
    coloredBackground: '60, 56, 56', // '245, 228, 213', // 101, 137, 115
    greenColor: '54, 168, 148', // '72, 127, 117',
    greenColorBright: '158, 212, 203', // '72, 127, 117',
    brownColor: '100, 92, 92',
    yellowColor: '255, 178, 67',
    textColor: colorMode === 'light' ? '#202346' : '#ffffff',
    textColorInverted: colorMode === 'dark' ? '#202346' : '#ffffff',
    textColorOnBackground: '255, 255, 255',// '96, 80, 73',
    textM: '1em',
    textS: '0.75em',
    greyLight: colorMode === 'light' ? '233,235,239' : '69,70,72',
    greyDark: colorMode === 'light' ? '#9298aa' : '#222426',
    mainColor: colorMode === 'light' ? '255, 126, 98' : '255, 126, 98',
    tenantColor:
      colorMode === 'light'
        ? tenant.key === '24heures'
          ? '#d9000b'
          : tenant.key === 'tdg'
          ? '#2c3890'
          : '#0a79bd'
        : '#ffffff',
  } as const)

export const getTheme = (colorMode: 'light' | 'dark', tenant: Tenant) => ({
  ...getPrimaryTheme(colorMode, tenant),
  ...createStyledBreakpointsTheme({
    breakpoints: {
      xs: '0px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
      xxl: '1400px',
      xxxl: '1580px',
    },
  }),
})
